import Link from "next/link";

import { getPublicConfig } from "@/helpers/getPublicConfig";

const {
  project: { companyName },
} = getPublicConfig();

const FooterLink = (
  { href, children }: { href: string; children: React.ReactNode },
) => (
  <Link
    href={href}
    passHref
    className="font-normal hover:opacity-70 text-gray-900"
  >
    {children}
  </Link>
);

const VerticalDivider = () => (
  <div className="px-0.5">
    <div className="h-3 w-px bg-gray-900" />
  </div>
);

export const Footer = () => {
  return (
    <footer className="flex flex-col items-center justify-center space-y-1 bg-gray-200 px-4 py-5 text-center text-sm font-light text-gray-900">
      <span className="flex items-center space-x-1">
        <FooterLink href="/faq">常見問題</FooterLink>
        <VerticalDivider />
        <FooterLink href="/faq">聯絡我們</FooterLink>
        <VerticalDivider />
        <FooterLink href="/termsOfService">服務條款</FooterLink>
        <VerticalDivider />
        <FooterLink href="/privacyPolicy">隱私政策</FooterLink>
      </span>
      <span className="opacity-70 text-gray-900">{`版權所有 © ${new Date().getFullYear()} ${companyName} 職業介紹所牌照 79407`}</span>
    </footer>
  );
};
